import Vue from 'vue';

export const GlobalEventEmitter = new Vue();
export const makeToast = (payload) => {
    return GlobalEventEmitter.$emit('makeToast', payload);
};
